/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiOfficesIdMutationRequest,
  PutApiOfficesIdMutationResponse,
  PutApiOfficesIdPathParams,
} from '../models/PutApiOfficesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiOfficesIdMutationResponseSchema,
  putApiOfficesIdMutationRequestSchema,
} from '../zod/putApiOfficesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiOfficesIdMutationKey = () =>
  [{ url: '/api/offices/:id' }] as const;

export type PutApiOfficesIdMutationKey = ReturnType<
  typeof putApiOfficesIdMutationKey
>;

/**
 * {@link /api/offices/:id}
 */
export async function putApiOfficesId(
  id: PutApiOfficesIdPathParams['id'],
  data: PutApiOfficesIdMutationRequest,
  config: Partial<RequestConfig<PutApiOfficesIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiOfficesIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiOfficesIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiOfficesIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/offices/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiOfficesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/offices/:id}
 */
export function usePutApiOfficesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiOfficesIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiOfficesIdPathParams['id'];
        data: PutApiOfficesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiOfficesIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiOfficesIdMutationKey();

  return useMutation<
    PutApiOfficesIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiOfficesIdPathParams['id'];
      data: PutApiOfficesIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiOfficesId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
